<template>
  <div v-loading="loading" class="container">
		<el-card shadow="hover" class="rate-card">
			<div slot="header" >
				<h1> {{rates.length}} </h1>
			</div>
			<p> OVERALL RATES </p>
		</el-card>
		<el-card shadow="hover" class="rate-card">
			<div slot="header" >
				<h1> {{unconfirmedRates}} / {{confirmedRates}} </h1>
			</div>
			<p> UNCONFIRMED RATES / CONFIRMED RATES </p>
		</el-card>
		<el-card shadow="hover" class="rate-card">
			<div slot="header" >
				<h1> {{suppliers.length}} </h1>
			</div>
			<p> TOTAL NUMBER OF SUPPLIERS </p>
		</el-card>
  </div>
</template>

<script>
import { getRatesApiPath } from '../../helpers/helpers'

export default {
  name: "home",
  components: {
  },
  data () {
    return {
		confirmedRates: 0,
		unconfirmedRates: 0,
		loading: true
    }
  },
  computed: {
    rates () {
      	return this.$store.getters.getRates
    },
    suppliers () {
      	return this.$store.getters.getSuppliers
    }
  },
  async created () {
    await this.$store.dispatch('fetchSuppliers')
    await this.getRatesApiPath()

    this.filterRates()
    this.loading = false
  },
  methods: {
    getRatesApiPath,
    filterRates () {      
		for (let rate of this.rates) {
			if (rate.confirmed_at) {
				this.confirmedRates++
			} else {
				this.unconfirmedRates++
			}
		}
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 5vw;
}
.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-self: center;
}
.rate-card-1 {
  flex: 1;
}
.rate-card-2 {
  flex: 1.5;
}
.rate-card-3 {
  flex: 1;
}
.rate-card { 
  padding-top: 15px;
  flex-basis: 33%;
  flex-grow: 1;
  text-align: center;
  min-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Home.vue